import { I18n } from '@calendly/i18n'

import { getBuffersOptions } from 'components/event_type_edit'

export const getSchedulingLimitsBufferOptions = () => (
  getBuffersOptions().map((option) => (
    option.value === '0'
      ? {
        ...option,
        name: I18n.t('publisher.event_type_editor_crud.scheduling_limits.no_buffer'),
      }
      : option
  ))
)
